import App from '@/pages/Index.vue'
import { bootstrapApp } from "@/bootstrapApp"
bootstrapApp(App, 'home');

